import { scheduledDetailedCopyHindi } from './scheduled-page-copy-translations-hi';
import { scheduledDetailedCopyIndonesian } from './scheduled-page-copy-translations-id';
import { scheduledDetailedCopyVietnamese } from './scheduled-page-copy-translations-vi';

export const scheduledDetailedCopyIndicSoutheastAsian = {
  ...scheduledDetailedCopyHindi,
  ...scheduledDetailedCopyIndonesian,
  ...scheduledDetailedCopyVietnamese,
};
